<script setup>
import CustomerForm from '@frontJs/components/forms/projectManagement/customers/CustomerForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const {
    tenant,
    tenantTypes,
    seoPackages,
    seaPackages,
    smoPackages,
    smaPackages,
    semPackages,
    devPackages,
    hostingPackages,
    outsourcingPackages,
    cloudflarePackages,
    emailingPackages,
    shoppingfeedPackages,
    performanceStagePackages,
    daysPackages,
    specialPackages,
    moduleTree,
    websiteVariants,
} = defineProps({
    tenant: {
        type: Object,
        required: false,
    },
    tenantTypes: {
        type: Array,
        required: true,
    },
    seoPackages: {
        type: Array,
        required: true,
    },
    seaPackages: {
        type: Array,
        required: true,
    },
    smoPackages: {
        type: Array,
        required: true,
    },
    smaPackages: {
        type: Array,
        required: true,
    },
    semPackages: {
        type: Array,
        required: true,
    },
    devPackages: {
        type: Array,
        required: true,
    },
    hostingPackages: {
        type: Array,
        required: true,
    },
    outsourcingPackages: {
        type: Array,
        required: true,
    },
    cloudflarePackages: {
        type: Array,
        required: true,
    },
    emailingPackages: {
        type: Array,
        required: true,
    },
    shoppingfeedPackages: {
        type: Array,
        required: true,
    },
    performanceStagePackages: {
        type: Array,
        required: true,
    },
    daysPackages: {
        type: Array,
        required: true,
    },
    specialPackages: {
        type: Array,
        required: true,
    },
    moduleTree: {
        type: Object,
        required: true,
    },
    websiteVariants: {
        type: Array,
        required: true,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="tenant">
            Mettre à jour le client #{{ tenant.id }} - Clients - Gestion de
            projet - Datakepler
        </title>

        <title v-else>
            Créer un client - Clients - Gestion de projet - Datakepler
        </title>
    </Head>

    <PageTitle v-if="tenant" :tenant-name="tenant.name">
        Gestion de projet - Clients - Mettre à jour le client #{{ tenant.id }}
    </PageTitle>

    <PageTitle v-else>
        Gestion de projet - Clients - Créer un client
    </PageTitle>

    <CustomerForm
        :tenant="tenant"
        :tenant-types="tenantTypes"
        :seo-packages="seoPackages"
        :sea-packages="seaPackages"
        :smo-packages="smoPackages"
        :sma-packages="smaPackages"
        :sem-packages="semPackages"
        :dev-packages="devPackages"
        :hosting-packages="hostingPackages"
        :outsourcing-packages="outsourcingPackages"
        :cloudflare-packages="cloudflarePackages"
        :emailing-packages="emailingPackages"
        :shoppingfeed-packages="shoppingfeedPackages"
        :performance-stage-packages="performanceStagePackages"
        :days-packages="daysPackages"
        :special-packages="specialPackages"
        :module-tree="moduleTree"
        :website-variants="websiteVariants"
    />
</template>
